import i18next from 'i18next';

import { preAuth } from 'common/api/auth';
import showToast from 'common/utils/showToast';

import {
    RESEND_CODE,
    RESEND_CODE_FAILURE,
    RESEND_CODE_SUCCESS,
} from '../actionTypes';
import { loginActions } from '../reducer';

import setAuthValues from './setAuthValues';
import showSecondStepAuthForm from './showSecondStepAuthForm';

export default (data) => (dispatch) => {
    dispatch(loginActions[RESEND_CODE]());

    const newValues = {
        email: data.email,
        password: data.password,
    };

    preAuth(newValues)
        .then((response) => {
            dispatch(showSecondStepAuthForm(false));
            dispatch(loginActions[RESEND_CODE_SUCCESS](response.data));
            dispatch(
                setAuthValues({
                    ...newValues,
                    validationToken: response.data.auth_token,
                }),
            );

            dispatch(showSecondStepAuthForm(true));
            showToast({ body: i18next.t('The code was successfully resent') });
        })
        .catch((error) =>
            dispatch(
                loginActions[RESEND_CODE_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
